import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
    selector: "loading-overlay-linear",
    templateUrl: "./loading-overlay-linear.component.html",
    styleUrls: ["./loading-overlay-linear.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, MatProgressBar],
})
export class LoadingOverlayLinearComponent {
    loaded = input.required<boolean>();
    center = input<boolean>(true);
    message = input<string>("Loading...");

    constructor() {}
}
